import Typography from '../../components/common/Typography/index'
import propTypes from 'prop-types'

const ErrorState = ({ error }) => {
  return (
    <div className="flex flex-col items-center justify-center h-[400px]">
      <i className="fa-solid fa-circle-exclamation text-danger text-9xl mt-36 mb-4" />
      <Typography variant="body" className="text-danger">
        Error: {error}
      </Typography>
    </div>
  )
}

export default ErrorState

ErrorState.propTypes = {
  error: propTypes.string.isRequired,
}
